import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "card",
  ref: "popup"
}
const _hoisted_2 = { class: "bg-white card-header" }
const _hoisted_3 = { class: "card-title d-flex justify-content-between" }
const _hoisted_4 = { class: "card-body pt-5 pb-5" }
const _hoisted_5 = { class: "card-footer fixed-bottom d-flex justify-content-end w-100 bg-light" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RatingHistory = _resolveComponent("RatingHistory")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_scroll_area = _resolveComponent("q-scroll-area")!
  const _component_q_drawer = _resolveComponent("q-drawer")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tw-sidebar-content", this.size ? 'tw-sidebar-'+this.size : '']),
    style: {"position":"relative","z-index":"1031"}
  }, [
    _createVNode(_component_q_drawer, {
      modelValue: _ctx.isDrawerOpen,
      "onUpdate:modelValue": [
        _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isDrawerOpen) = $event)),
        _ctx.onClose
      ],
      breakpoint: 2000,
      "no-swipe-close": "",
      bordered: "",
      side: "right",
      class: "bg-white"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_scroll_area, { style: {"height":"100%"} }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("h4", null, _toDisplayString(_ctx.$t("good.globalLabels." + _ctx.label)), 1),
                  _createElementVNode("span", {
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args))),
                    class: "cursor-pointer"
                  }, [...(_cache[2] || (_cache[2] = [
                    _createElementVNode("svg", {
                      width: "30",
                      height: "30",
                      viewBox: "0 0 30 30",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, [
                      _createElementVNode("rect", {
                        opacity: "0.5",
                        x: "6",
                        y: "17.3137",
                        width: "16",
                        height: "2",
                        rx: "1",
                        transform: "rotate(-45 6 17.3137)",
                        fill: "currentColor"
                      }),
                      _createElementVNode("rect", {
                        x: "7.41422",
                        y: "6",
                        width: "16",
                        height: "2",
                        rx: "1",
                        transform: "rotate(45 7.41422 6)",
                        fill: "currentColor"
                      })
                    ], -1)
                  ]))])
                ])
              ]),
              _createVNode(_component_RatingHistory),
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.component), _normalizeProps(_guardReactiveProps(_ctx.props)), null, 16))
              ]),
              _createElementVNode("div", _hoisted_5, [
                _withDirectives(_createVNode(_component_q_btn, {
                  color: "transparent",
                  label: _ctx.$t('good.globalLabels.cancelButton'),
                  onClick: _ctx.onClose,
                  class: "btn text-body"
                }, null, 8, ["label", "onClick"]), [
                  [_vShow, _ctx.notDisplaySave]
                ]),
                _withDirectives(_createVNode(_component_q_btn, {
                  color: "primary",
                  label: _ctx.$t('good.globalLabels.save'),
                  onClick: _ctx.onSave,
                  class: "btn",
                  disable: ( _ctx.disableSave?? !_ctx.saveAuthorized )
                }, null, 8, ["label", "onClick", "disable"]), [
                  [_vShow, _ctx.notDisplaySave]
                ])
              ])
            ], 512)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "onUpdate:modelValue"])
  ], 2))
}